import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Bot, X } from "lucide-react";

const STORAGE_KEY = "myna-ai-disclosure-dismissed";

export function AIDisclosureBanner() {
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === "true") setDismissed(true);
  }, []);

  const handleDismiss = () => {
    setDismissed(true);
    localStorage.setItem(STORAGE_KEY, "true");
  };

  if (dismissed) return null;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -10 }}
        className="relative bg-gradient-to-r from-lime-500/10 to-lime-400/10 border border-lime-500/20 rounded-lg p-4 mb-6"
      >
        <button
          onClick={handleDismiss}
          className="absolute top-3 right-3 text-gray-500 hover:text-gray-300 transition-colors"
          aria-label="Dismiss AI disclosure"
        >
          <X className="h-4 w-4" />
        </button>

        <div className="flex items-start gap-3 pr-6">
          <div className="w-9 h-9 bg-lime-500/15 border border-lime-500/20 rounded-lg flex items-center justify-center shrink-0">
            <Bot className="h-5 w-5 text-lime-400" />
          </div>
          <div>
            <h3 className="font-bold text-sm text-gray-100 mb-1">
              AI-Powered Demo Experience
            </h3>
            <p className="text-xs text-gray-400 leading-relaxed">
              This demo uses MYNA AI — the same artificial intelligence that will answer calls for your
              business 24/7. The voice you hear is AI-generated, not a human receptionist.
            </p>
          </div>
        </div>
      </motion.div>
    </AnimatePresence>
  );
}
